import React, { useMemo, useState } from 'react';
import Modal from 'react-modal';

import { WorkoutStatus } from '../../constants/enums';
import ProgressLine from '../progress-line/ProgressLine';
import SingleTraineeResults from './SingleTraineeResults';
import WorkoutBlock from '../add-calendar-modal/WorkoutBlock';

import { useUtils } from '../../hooks';

import {
  WholeWrapper,
  ModalHeader,
  ModalCloseX,
  WorkoutName,
  EntireGroupResults,
  EntireGroupHeader,
  EntireGroupHeading,
  EntireGroupResultsWrapper,
  EntireGroupContent,
  WorkoutBlockResult,
  BlockExercisesSide,
  BlockExercisesHeader,
  BlockFeedbackSide,
  BlockFeedback,
  BlockFeedbackHeader,
  GroupWorkoutsWrapper,
  GroupParticipantsHeader,
  GroupParticipantsContent,
  GroupParticipantRow,
  GroupParticipantImage,
  GroupParticipantName,
  GroupParticipantResultIndicator,
  IndicatorDone,
  IndicatorGeneral,
  HoverIndicator,
} from './components';
import Loader from '../loader/Loader';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const customStyles = {
  overlay: {
    backgroundColor: '#05000066',
    zIndex: 3333,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: 'hidden auto',
  },
  content: {
    width: '74%',
    maxWidth: '1320px',
    minWidth: '1080px',
    minHeight: 'Calc(100vh - 64px)',
    height: 'fit-content',
    borderRadius: '8px',
    overflow: 'hidden',
    pointerEvents: 'all',
    background: 'white',
    margin: '4rem auto',
    position: 'static',
    padding: 0,
  },
};

const CalendarResultsModal = ({
  day,
  name,
  closeModal,
  refetchProgram,
  loading,
  alert,
  urlTraineeUid,
}) => {
  const { getWorkoutBlocksByWorkout, sortByWorkoutStatus } = useUtils();
  const [chosenIndividual, setChosenIndividual] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();
  const workoutBlocks = useMemo(
    () => (day?.workout?.status?.length < 2 ? undefined : getWorkoutBlocksByWorkout(day?.workout)),
    [day, getWorkoutBlocksByWorkout],
  );
  const [participants, doneBy] = useMemo(
    () => [
      day?.workout?.status?.length,
      day?.workout?.status?.filter((x) => x.type === WorkoutStatus.DONE)?.length,
    ],
    [day],
  );

  useEffect(() => {
    console.log(urlTraineeUid, '---');
    const urlTrainee = day?.workout?.status?.find((x) => x?.trainee?.uid === urlTraineeUid);
    setChosenIndividual((curr) => urlTrainee?.trainee || curr);
  }, [urlTraineeUid]);

  return (
    <>
      <Modal
        onRequestClose={() => {
          closeModal();
          history.push(`${history?.location?.pathname}${participants > 1 ? '?group=true' : ''}`);
        }}
        isOpen={!!day}
        style={customStyles}
        contentLabel="Program Request"
        ariaHideApp={false}
      >
        <div>
          {loading || submitting ? (
            <Loader />
          ) : (
            <WholeWrapper>
              <ModalHeader>
                {name ? `${name} - ` : ''}
                {`Day ${day?.programDay}`}
                <ModalCloseX onClick={closeModal}>X</ModalCloseX>
              </ModalHeader>
              <WorkoutName>
                <span>Workout Name: </span> {day?.workout?.name}
              </WorkoutName>
              {participants > 1 && !chosenIndividual ? (
                <EntireGroupResultsWrapper>
                  <EntireGroupResults>
                    <EntireGroupHeader>
                      <EntireGroupHeading>Completed Workout</EntireGroupHeading>
                    </EntireGroupHeader>
                    <ProgressLine total={participants} progress={doneBy} />
                    <EntireGroupContent>
                      <WorkoutBlockResult>
                        <BlockExercisesSide>
                          <BlockExercisesHeader>Workouts</BlockExercisesHeader>
                          <GroupWorkoutsWrapper>
                            {workoutBlocks?.map((block) => (
                              <WorkoutBlock key={block.uid} immutable block={block} />
                            ))}
                          </GroupWorkoutsWrapper>
                        </BlockExercisesSide>
                        <BlockFeedbackSide>
                          <BlockFeedback style={{ background: '#fafafa' }}>
                            <BlockFeedbackHeader>
                              <GroupParticipantsHeader>
                                Customers
                                <div>{`${doneBy}/${participants}`}</div>
                              </GroupParticipantsHeader>
                            </BlockFeedbackHeader>
                            <GroupParticipantsContent>
                              {day?.workout?.status?.sort(sortByWorkoutStatus)?.map((status) => (
                                <GroupParticipantRow
                                  key={status.uid}
                                  onClick={() => setChosenIndividual(status?.trainee)}
                                >
                                  <HoverIndicator
                                    className="hover_indicator"
                                    width="0.3rem"
                                    height="60%"
                                  />
                                  <GroupParticipantImage>
                                    {status?.trainee?.fullName
                                      ?.split(' ')
                                      ?.map((a) => a.substr(0, 1))
                                      .join('')}
                                  </GroupParticipantImage>
                                  <GroupParticipantName>
                                    {status?.trainee?.fullName}
                                  </GroupParticipantName>
                                  <GroupParticipantResultIndicator>
                                    {status?.type === WorkoutStatus.DONE ? (
                                      <IndicatorDone />
                                    ) : (
                                      <IndicatorGeneral status={status?.type} />
                                    )}
                                  </GroupParticipantResultIndicator>
                                </GroupParticipantRow>
                              ))}
                            </GroupParticipantsContent>
                          </BlockFeedback>
                        </BlockFeedbackSide>
                      </WorkoutBlockResult>
                    </EntireGroupContent>
                  </EntireGroupResults>
                </EntireGroupResultsWrapper>
              ) : (
                <SingleTraineeResults
                  day={day}
                  alert={alert}
                  trainee={chosenIndividual || day?.workout?.status?.[0]?.trainee}
                  isGroup={participants > 1}
                  exit={() => setChosenIndividual(null)}
                  refetchProgram={refetchProgram}
                  setSubmitting={setSubmitting}
                  closeModal={closeModal}
                />
              )}
            </WholeWrapper>
          )}
        </div>
      </Modal>
    </>
  );
};

export default CalendarResultsModal;
